import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '../node_modules/lib-flexible/flexible.js'
import Echarts from 'vue-echarts'
import 'echarts'
createApp(App)
    .use(store)
    .use(router)
    .component('ECharts',Echarts)
    .mount('#app')
